export const lang = {
  companyName: 'NESC',
  /* 首页 */
  home: 'Home',

  /* 关于我们 */
  aboutUs: 'About Us',
  companyProfile: 'Company Profile',
  news: 'News',
  honor: 'Honor Certificate',
  /* 产品系列 */
  productGroup: 'Products',
  highRateCell: 'High Rate BatteryCell',
  batteryModule: 'Battery Module',

  /* 行业解决方案 */
  industrySolutions: 'Solutions',
  shippingIndustrySolution: 'Last-mile Delivery Industry',
  deliveryIndustrySolution: 'Instant Delivery Industry',
  policeIndustrySolution: 'Administrative Law Enforcement Industry',
  parkIndustrySolution: 'Attractions Shuttle',
  solutionTxt: ' Solutions',
  solutionTxt1: 'We provides a safe and convenient minute-level super-fast charging system solution for electric two and three-wheelers used in the end of the delivery industry. It is applied in the "last mile" scenarios of urban instant logistics, combined with the "Instant Power Cloud" service, significantly improving site circulation efficiency and personnel dispatching efficiency, saving operational costs, and enhancing station revenue.',
  solutionTxt2: 'We provides a minute-level super fast charging solution for electric two-wheeled takeaway vehicles, with digital security control throughout the life cycle, charging and using at any time, and can quickly replenish energy at a low temperature of -20°C, receiving more orders and generating more efficient revenue!',
  solutionTxt3: 'We provides energy system solutions with minute-level super fast charging, super safety and quick response for the patrol emergency vehicles of administrative departments such as city administration, environmental sanitation administration, fire rescue bureau, industry and commerce administration, post office, and public institutions.',
  solutionTxt4: 'We has developed a 3~6KWh battery pack for various complex working conditions such as logistics centers, ports, tourist attractions, and golf courses. "Charging is like refueling" to provide capacity services around the clock, effectively solving peak capacity shortages and troughs excess assets.',

  /* 产品解决方案 */
  productSolutions: 'Products',
  electricalBike: 'Electric Bicycle',
  electricalMoto: 'Electric Motorcycle',
  electricalThreeWheel: 'Electric Tricycle',
  electricalFourWheel: 'Four Wheeled Vehicles',
  agv: 'AGV',

  /* 产品技术优势 */
  techAdvantages: 'Technology',
  techIot: 'Smart IoT Technology',
  techSFC: 'LVDC SFC Technology',
  techBatteryPack: 'MFC Li-ion Battery Pack',

  /* 创新技术 */
  technology: 'R&D',
  materialTechnology: 'Material Technology',
  structuralTechnology: 'Structural Technology',
  cloudPlatform: 'Safety Technology',
  // 瞬电云中心
  shunDianCloud: 'Cloud Platform',
  shunDianBigData: 'Sundn Cloud Big Data',
  BatteryCount: 'BatteryCount',
  ChargingPileCount: 'ChargingPileCount',
  StationCount: 'StationCount',
  UserCount: 'UserCount',
  ChargingTimes: 'ChargingTimes',
  ChargingMinutes: 'ChargingMinutes',
  Mileages: 'Mileages',
  ChargingAmount: 'ChargingAmount',
  DuraionRatio: 'DuraionRatio',
  danweiZu: '',
  danweiTai: '',
  danweiGe: '',
  danweiMing: '',
  // 代理商加盟
  agent: 'Agent',
  /* 联系我们 */
  contactUs: 'Contact Us',
  talentRecruitment: 'Talent Recruitment',
  channelCooperation: 'Channel Cooperation',
  bidAnnouncement: 'Bid Announcement',

  privacyPolicyInformationSecurity: 'Privacy and Information Security',
  legalNote: 'Legal',

  homeText: 'Build a new scene of super fast charging',
  homeText1: 'Charging like refueling',

  newsTitle: 'News',
  checkMore: 'Check More',

  vision: 'Vision',
  visionContent: 'Drive the world\'s energy transformation with ultra-electric power',
  mission: 'Mission',
  missionContent: 'Keep Innovation for unlimited energy of users',
  coreValue: 'Core Value',
  coreValueContent: 'Innovation &nbsp; Excellence &nbsp; Integrity &nbsp; Win',
  companyProfileInfo: 'Established in 2018, Jiangsu Sundn Network Technology Co., Ltd. is a ' +
    'Network, cloud computing, and big data-based new energy operation solution provider. Company ' +
    'Focus on the safe operation of power batteries and efficient charging management, through the whole life cycle master ' +
    'Dynamic monitoring realizes the safe operation and charging of power batteries with long life, wide temperature range, and high rate ' +
    'manage. The company has a number of software patents and comprehensive software and hardware solutions, which have been ' +
    'New energy users in various fields such as logistics, public security, fire protection, and commercial use provide a full range of security' +
    'Full and efficient service。',
  previous: 'Prev',
  next: 'Next',
  jobTitle: 'Job Title',
  jobCategories: 'Job Categories',
  numberOfRecruits: 'Number Of Recruits',
  workPlace: 'Work Place',
  releaseDate: 'Release Date',
  more: 'More',
  operate: 'Operate',
  check: 'Details',
  address: 'Address',
  phone: 'Phone',
  email: 'Email',
  choseLanguage: 'Language',
  joinUs: 'Join',
  contactPhone: 'Tel No.',
  PersonName: 'Name',
  SexMan: 'Mr',
  SexWoman: 'Mrs',
  Comments: 'Current industry and situation',
  CooperArea: 'CooperArea',
  Province: 'Province',
  City: 'City',
  Area: 'Area',
  InvestBudget: 'InvestBudget',
  addressInfo: 'No.50, the ZhuJiang Road, XinWu District, WuXi City, Jiangsu Province',
  hasRead: 'I have read and agree to the official website of Sundn',
  privatePolicy: 'Privacy Policy',
  submit: 'Submit',
  privatePolicy1: 'In order to serve you better, please fill in the above content carefully. We will protect your personal privacy in accordance with relevant laws and regulations, and will contact you as soon as possible.'
}
